/* The Saga series pages: the gallery and pickers on a product page, the finish switch on the collection page, and
   the consultation dialog on both. No cart anywhere: the baths are sold through a consultation. */
(function () {
  if (window.__ikSaga) return;
  window.__ikSaga = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* A radiogroup of swatches: arrows move and pick, Home/End jump, a click picks. */
  function radioGroup(group, onPick) {
    var opts = Array.prototype.slice.call(group.querySelectorAll('[role=radio]'));
    function pick(btn, focus) {
      opts.forEach(function (o) {
        var on = o === btn;
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.tabIndex = on ? 0 : -1;
      });
      if (focus) btn.focus();
      onPick(btn);
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { pick(o, false); }); });
    group.addEventListener('keydown', function (e) {
      var i = opts.indexOf(document.activeElement);
      var n = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (e.key === 'Home') n = -i;
      if (e.key === 'End') n = opts.length - 1 - i;
      if (n === undefined) return;
      e.preventDefault(); e.stopPropagation();
      pick(opts[(Math.max(i, 0) + n + opts.length) % opts.length], true);
    });
  }

  /* Swap an <img> to a new picture without a blank frame: load it first, then fade. */
  function swapImg(img, src, srcset, alt) {
    if (!img || img.getAttribute('src') === src) return;
    var pre = new Image();
    if (srcset) { pre.srcset = srcset; pre.sizes = img.sizes || '100vw'; }
    pre.src = src;
    var done = function () {
      if (reduce) { img.src = src; if (srcset) img.srcset = srcset; if (alt != null) img.alt = alt; return; }
      img.classList.add('is-fading');
      setTimeout(function () {
        img.src = src; if (srcset) img.srcset = srcset; if (alt != null) img.alt = alt;
        requestAnimationFrame(function () { img.classList.remove('is-fading'); });
      }, 180);
    };
    if (pre.decode) pre.decode().then(done, done); else pre.onload = done;
  }

  /* ---------- consultation dialog ---------- */
  function initConsult(root) {
    var dlg = root.querySelector('.ik-consult');
    if (!dlg) return;
    var state = { finish: '', cover: '' };
    function fill() {
      var f = dlg.querySelector('[data-ik-consult-finish]'); if (f) f.value = state.finish;
      var c = dlg.querySelector('[data-ik-consult-cover]'); if (c) c.value = state.cover;
      var l = dlg.querySelector('[data-ik-consult-choice-label]');
      if (l) l.textContent = [state.finish, state.cover].filter(Boolean).join(' · ');
    }
    root.__ikConsult = { set: function (k, v) { state[k] = v; fill(); } };
    root.querySelectorAll('[data-ik-consult-open]').forEach(function (b) {
      b.addEventListener('click', function () { fill(); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-ik-consult-close]')) dlg.close();
    });
    // after a post, Shopify renders the same page with the result in the form: show it
    if (dlg.querySelector('[data-ik-consult-posted], [data-ik-consult-errors]') && dlg.showModal) dlg.showModal();
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ik-saga-variants]').textContent); } catch (e) {}
    var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });
    var row = root.querySelector('[data-ik-row]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ik-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ik-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ik-saga-gallery__dots li'));
    var caption = root.querySelector('[data-ik-caption]');
    var count = root.querySelector('[data-ik-count]');
    var desktop = window.matchMedia('(min-width: 990px)');
    var index = 0;
    var currentTitle = (root.querySelector('[data-ik-finish-name]') || {}).textContent || '';

    function captionFor(i) {
      if (i === 0) return (caption ? caption.dataset.in : 'I') + ' ' + currentTitle;
      return slides[i].dataset.caption || '';
    }
    function show(i, fromScroll) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-current', k === index); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-current', k === index); t.setAttribute('aria-current', k === index ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-current', k === index); });
      if (caption) caption.textContent = captionFor(index);
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      if (!desktop.matches && !fromScroll && row) row.scrollTo({ left: index * row.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.ikThumb); }); });
    root.querySelectorAll('[data-ik-step]').forEach(function (b) { b.addEventListener('click', function () { show(index + +b.dataset.ikStep); }); });
    if (row) row.addEventListener('scroll', function () {
      if (desktop.matches || !row.clientWidth) return;
      var k = Math.round(row.scrollLeft / row.clientWidth);
      if (k !== index) show(k, true);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var t = e.target;
      if (t && (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.closest('[role=radiogroup]') || t.closest('dialog'))) return;
      var r = root.querySelector('.ik-saga-top').getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      show(index + (e.key === 'ArrowRight' ? 1 : -1));
    });

    var finishGroup = root.querySelector('[data-ik-finish-group]');
    if (finishGroup) radioGroup(finishGroup, function (btn) {
      var v = byId[btn.dataset.ikFinish]; if (!v) return;
      currentTitle = v.title;
      root.querySelector('[data-ik-finish-name]').textContent = v.title;
      swapImg(root.querySelector('[data-ik-slide="0"] img'), v.src, v.srcset, null);
      var th = root.querySelector('[data-ik-thumb="0"] img'); if (th) th.src = v.thumb;
      show(0);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
      if (root.__ikConsult) root.__ikConsult.set('finish', v.title);
    });
    var coverGroup = root.querySelector('[data-ik-cover-group]');
    if (coverGroup) radioGroup(coverGroup, function (btn) {
      root.querySelector('[data-ik-cover-name]').textContent = btn.dataset.ikCover;
      if (root.__ikConsult) root.__ikConsult.set('cover', btn.dataset.ikCover);
    });
    if (root.__ikConsult) {
      root.__ikConsult.set('finish', currentTitle);
      var c0 = root.querySelector('[data-ik-cover-group] [aria-checked="true"]');
      if (c0) root.__ikConsult.set('cover', c0.dataset.ikCover);
    }

    // the other finishes load once the page is idle, so a pick is instant
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(function () { variants.forEach(function (v) { var i = new Image(); i.decoding = 'async'; i.sizes = '55vw'; i.srcset = v.srcset; i.src = v.src; }); });
  }

  /* ---------- collection page ---------- */
  function initCollection(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ik-saga-card')).map(function (li) {
      var data = {}; try { data = JSON.parse(li.querySelector('[data-ik-card-variants]').textContent); } catch (e) {}
      return { li: li, data: data };
    });
    var group = root.querySelector('[data-ik-coll-finish]');
    if (!group) return;
    radioGroup(group, function (btn) {
      var f = btn.dataset.ikCollPick;
      root.querySelector('[data-ik-coll-name]').textContent = f;
      cards.forEach(function (c) {
        var v = c.data[f]; if (!v) return;
        swapImg(c.li.querySelector('.ik-saga-card__photo'), v.src, v.srcset, null);
        var a = c.li.querySelector('[data-ik-card-link]'); a.href = a.dataset.base + '?variant=' + v.id;
        c.li.querySelectorAll('[data-ik-card-sw]').forEach(function (s) { s.classList.toggle('is-current', s.dataset.ikCardSw === f); });
      });
    });
  }

  function init() {
    document.querySelectorAll('.ik-saga').forEach(function (root) {
      initConsult(root);
      if (root.hasAttribute('data-ik-saga-product')) initProduct(root);
      if (root.hasAttribute('data-ik-saga-collection')) initCollection(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
